import * as React from 'react';
import { DMDiv, DMInput, DMLabel, DMText } from './Primitives';

export const RequiredStar = () => (
  <DMText as="span" className="ml-[0.25vw] text-red-500">
    *
  </DMText>
);

type FieldLabelProps = {
  children: React.ReactNode;
  className: string;
  required?: boolean;
};

export const FieldLabel = ({
  children,
  className,
  required = false,
}: FieldLabelProps) => (
  <DMLabel className={className}>
    {children}
    {required && <RequiredStar />}
  </DMLabel>
);

type BasicTextFieldProps = {
  label: string;
  name: string;
  placeholder: string;
  value: string;
  inputClassName: string;
  labelClassName: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  type?: string;
  icon?: React.ReactNode;
  required?: boolean;
};

export const BasicTextField = ({
  label,
  name,
  placeholder,
  value,
  inputClassName,
  labelClassName,
  onChange,
  type = 'text',
  icon,
  required = false,
}: BasicTextFieldProps) => (
  <DMDiv>
    <FieldLabel className={labelClassName} required={required}>
      {label}
    </FieldLabel>
    <DMDiv className="relative">
      <DMInput
        name={name}
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        className={`${inputClassName} ${icon ? 'pr-[3vw]' : ''}`}
      />
      {icon && (
        <DMDiv className="pointer-events-none absolute right-[1vw] top-1/2 -translate-y-1/2 text-black">
          {icon}
        </DMDiv>
      )}
    </DMDiv>
  </DMDiv>
);
